module.exports = __webpack_public_path__ + "static/assets/84afe35b55d52ba599dd832d0b503374.png";